import styled from 'styled-components'
import { Link } from "react-router-dom"

export const InseminationStyled = styled.div``

export const StyledLinkReport = styled(Link)`
    display: flex;
    justify-content: center;
`